<div class="row">
  <div class="caption" [ngStyle]="cStyle">{{caption}}</div>
  <div class="value" [ngStyle]="vStyle">{{value}} {{unit}}</div>
</div>